import appOnboardingModalSlice from './slice';

// eslint-disable-next-line import/prefer-default-export
export const { flagAppOnboardingModalStep, unflagAppOnboardingModalStep, setSelectedExperienceOption, setPartnerName } =
  appOnboardingModalSlice.actions;
